export default "__VITE_ASSET__EuceSWor__"